import { render, staticRenderFns } from "./ArticleListLeft.vue?vue&type=template&id=25580447&scoped=true"
import script from "./ArticleListLeft.vue?vue&type=script&lang=js"
export * from "./ArticleListLeft.vue?vue&type=script&lang=js"
import style0 from "./ArticleListLeft.vue?vue&type=style&index=0&id=25580447&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25580447",
  null
  
)

export default component.exports